import { useEffect } from "react";
import i18n from "../../i18n.js";
import { useHistory } from "react-router-dom";
import usePersonaStore from "../../Store/PersonaStore.jsx";
import useAuthStore from "../../Store/AuthStore.jsx";
import { createPersonaAPI } from "../../Services/userService.js";
import {
  getUnauthSearchText,
  getPendingPersonaData,
  clearAllPersonaData,
  clearPendingPersonaData,
} from "../../Services/personaService.js";

const PostAuthPersonaHandler = () => {
  const history = useHistory();
  const {
    setShowCreatePersonaForUnauthUser,
    setGeneratedPersonaData,
    fetchUserPersonas,
    setSelectedPersona
  } = usePersonaStore();
  const { isAuthenticated } = useAuthStore();

  useEffect(() => {
    const handlePostAuthPersonaCreation = async () => {
      // Check if we have the necessary data to create a persona after authentication
      const unauthUserSearchText = getUnauthSearchText();

      if (isAuthenticated && unauthUserSearchText) {
        try {
          // Check if we have pending persona data from the form
          const personaData = getPendingPersonaData();

          // Only create persona if user explicitly filled out the form
          if (personaData) {
            // Get the store to access all state setters
            const store = usePersonaStore.getState();

            // Set flag to prevent persona generation during creation (race condition fix)
            store.setIsCreatingPersona(true);

            // Store the name of the persona we're about to create
            const personaNameToSelect = personaData.name;

            // Call the create persona API with the actual persona data
            const response = await createPersonaAPI(personaData, "", i18n.language);

            if (response.success) {
              // Refresh personas to include the newly created one and get the updated list
              const updatedPersonas = await fetchUserPersonas();

              // Find the newly created persona by name in the updated list
              const newPersona = updatedPersonas.find(p => p.name === personaNameToSelect);
              if (newPersona) {
                // Clear all generated persona state before selecting the new persona
                store.setShowGeneratedPersonaAvatar(false);
                store.setPersonaName("");
                store.setShowFullPersona(true);
                store.setIsProgrammaticSelection(true);

                // Now select the persona
                setSelectedPersona(newPersona);

                // Clear flags after selection completes
                setTimeout(() => {
                  store.setIsProgrammaticSelection(false);
                  store.setIsCreatingPersona(false);
                }, 500);
              } else {
                // Clear the flag if persona not found
                store.setIsCreatingPersona(false);
              }

              // Clear all temporary state after successful creation
              setShowCreatePersonaForUnauthUser(false);
              setGeneratedPersonaData(null);
              clearAllPersonaData();
            } else {
              // Even if creation fails, clear the pending data and flag to avoid infinite retries
              clearPendingPersonaData();
              store.setIsCreatingPersona(false);
            }
          }
          // If no pendingPersonaData, don't create a persona automatically
          // The user can create one manually later if they want

        } catch (error) {
          console.error("Error creating persona after authentication:", error);
          // Clear the pending data even if persona creation fails
          clearPendingPersonaData();
        }
      }
    };

    handlePostAuthPersonaCreation();
  }, [isAuthenticated, history]);

  return null; // This component doesn't render anything
};

export default PostAuthPersonaHandler;